import type { StackProps } from '@frontend/web-react';
import { Icon, Text, XStack } from '@frontend/web-react';
import type { ClassName } from '@frontend/web-utils';
import { mergeAndConcatClasses } from '@frontend/web-utils';
import { useNavigate } from '@tanstack/react-router';

export type FeedbackButtonProps = {
  className?: ClassName;
  draftId?: string;
  style?: StackProps['style'];
  taskId?: string;
};

export const FeedbackButton = ({ className, draftId, style, taskId }: FeedbackButtonProps) => {
  const navigate = useNavigate();

  return (
    <XStack
      accessibilityLabel="Provide feedback"
      className={mergeAndConcatClasses(
        'bg-neutral-100 hover-opacity-effect flex items-center justify-center gap-x-xs rounded-[16px] h-[36px] px-md cursor-pointer',
        className,
      )}
      onClick={() =>
        navigate(
          taskId || draftId
            ? {
                search: { ...(taskId ? { taskId } : {}), ...(draftId ? { draftId } : {}) },
                to: '/app/settings/feedback',
              }
            : { to: '/app/settings/feedback' },
        )
      }
      style={style}
    >
      <Icon color="primary" name="IconFlag" size={18} />
      <Text className="leading-none font-bold" color="primary" type="h6">
        Feedback
      </Text>
    </XStack>
  );
};
